export const AD_MANAGER_SUBROUTES = [
  { name: "Games", path: "/account/ads/games" },
  { name: "My Earnings", path: "/account/ads/earnings" },
  { name: "Settings", path: "/account/ads/settings" },
];
